import React from 'react'
import cuid from 'cuid'
import classnames from 'classnames'
import Configurator from '../../../configurator'
import { i18n } from '../../../validator'

/**
 * @description Base input definition
 *      USAGE
 *          <Select
 *              *** PROPS ***
 *          />
 *
 *      PROPS - this props are required
 *          options             - options for select (can be Array of numbers, strings or objects)
 *
 *      PROPS - all props are optional
 *          id                  - id of select with label (if not defined, id will be generated)
 *          label               - label title (if not defined or null, is not showed)
 *          error               - if is error, set this to true
 *          disabled            - disable select
 *          value               - default value for select
 *          required            - if select is required
 *          withoutArrow        - if select should be without arrow
 *          className           - additional classes for select
 *          labelClassName      - additional classes for label
 *          containerClassName  - additional classes for container
 *
 */
@i18n()
export default class Select extends Configurator {
    state = {
        id: this.props.id || cuid(),
    }

    /**
     * Render one option of select
     * @param {number|string|Object} item
     * @returns {null|*}
     */
    renderOption = item => {
        if (typeof item === 'number' || typeof item === 'string') {
            return <option key={item} value={item}>{item}</option>
        } else if (typeof item === 'object') {
            return Object.entries(item).map(([key, value]) =>
                <option key={key} value={key}>{value}</option>
            )
        }

        return null
    }

    /**
     * Render
     * @return {*}
     */
    render = () => {
        const {
            label,
            labelClassName,
            containerClassName,
            className,
            error,
            required,
            withoutArrow,
            options,
            value,
            t,
            ...restProps
        } = this.props
        const { id } = this.state

        if (!options) {
            return null
        }

        return (
            <div className={classnames({
                [containerClassName]: !!containerClassName,
            })}>
                {label &&
                    <label
                        htmlFor={id}
                        className={classnames({
                            [labelClassName]: !!labelClassName,
                        })}
                    >
                        {label}
                        {required &&
                            <small className="text-danger">&nbsp;({t('required')})</small>
                        }
                    </label>
                }
                <select
                    id={id}
                    value={value}
                    className={classnames({
                        'custom-select': true,
                        'custom-select--without-arrow': withoutArrow,
                        'custom-select--error': error,
                        [className]: !!className,
                    })}
                    required={required}
                    {...restProps}
                >
                    {options.map(option => this.renderOption(option))}
                </select>
            </div>
        )
    }
}
